<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import moment from "moment";

export default {
	page: {
		title: 'Документы',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: 'Документы',
            items: [],
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            sortBy: null,
            sortDesc: true,
            fields: [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'created_at', label: 'Дата создания', sortable: true },
                { key: 'name', label: 'Наименование', sortable: true },
                { key: 'number', label: 'Номер', sortable: true },
                { key: 'company_name', label: 'Компания', sortable: true },
                { key: 'sum', label: 'Сумма', sortable: true },
                { key: 'actions', label: '', row:{'uuid':''}},
                { key: 'action', label: ''}
            ],

            dateConfig: {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd.m.Y',
            },

            date_start: moment().subtract('days', 7).format('DD.MM.YYYY'),
            date_end: moment().format('DD.MM.YYYY'),
            selectedDate: [moment().subtract('days', 7).format('DD.MM.YYYY'), moment().format('DD.MM.YYYY')],

            tableLoading: true,
            watch: false,
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['documents/GET_DOCUMENTS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['documents/GET_DOCUMENTS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {

        this.date_start = this.selectedDate[0];
        this.date_end   = this.selectedDate[1];

        await this.getData();
    },

    methods: {
        getPrintURL(row){
            return 'https://api.client.za-bota.com/pdf/?type=invoice&token=' + window.localStorage.getItem('API_KEY_ZABOTA') + '&uuid=' + row.item.uuid;
        },
        async onChangePeriod(item){
            if(item[0] && item[1]){
                this.date_start = moment(item[0]).format('DD.MM.YYYY')
                this.date_end   = moment(item[1]).format('DD.MM.YYYY')
                await this.getData();
            }
        },
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            let data_send = {
                'type'       : 'invoice',
                'limit'      : this.perPage,
                'page'       : this.currentPage,
                'sortBy'     : this.sortBy,
                'date_start' : this.date_start,
                'date_end'   : this.date_end,
                'sortDesc'   : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'     : this.filter,
                'filterOn'   : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('documents/FETCH_DOCUMENTS_LIST', data_send);
            this.watch = true;
        }
    },
}

</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0"><i class="feather uil uil-bill"></i>{{ title }}</h4>
            </div>

            <div class="col-sm-8 col-xl-6">
                <div class="btn-group" style="float: right">
                    <router-link to="/account/payments/create" class="btn btn-primary" right>
                        <i class="uil uil-file-alt " style="margin-right: 5px"></i>Выставить счет
                    </router-link>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <div class="form-group mb-sm-0">
                                <label class="d-inline-flex align-items-center">
                                    Период: 
                                    <flat-pickr
                                        v-model="selectedDate"
                                        class="form-control ml-2"
                                        :config="dateConfig"
                                        @on-change="onChangePeriod"
                                        name="date"
                                    ></flat-pickr>
                                </label>
                                <label class="ml-3 d-inline-flex align-items-center">
                                    Поиск: 
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        @change="onFiltered()"
                                        placeholder="Введите текст..."
                                        class="form-control form-control-md ml-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                            >
                                <template #cell(action)="row">
                                    <div style="text-align: right;">
                                        <b-dropdown
                                            variant="link"
                                            class="float-right"
                                            right
                                            toggle-class="p-0 text-muted arrow-none"
                                        >
                                            <template v-slot:button-content>
                                                <i class="uil uil-ellipsis-v font-size-14"></i>
                                            </template>
                                            <b-dropdown-item :to="{ name: 'Payments.edit', params: { document_uuid: row.item.uuid, copy: true }}"
                                                ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                            >
                                            <b-dropdown-item :href="getPrintURL(row)"
                                                ><i class="uil uil-export mr-2"></i>Редактировать</b-dropdown-item
                                            >
                                        </b-dropdown>  
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
	</Layout>
</template>

<style>
    .table.b-table td{
        vertical-align: middle;
    }
    .table-responsive-sm{
        transition: all .5s;
    }
    .table-responsive-sm.loading{
        opacity: 0.3;
    }
</style>